import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

type SearchInputSize = "medium" | "small";

export const Wrap = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const Input = styled.input<{ $size: SearchInputSize }>`
    width: 100%;
    height: ${({ $size }) => ($size === "small" ? "40px" : "44px")};
    padding: ${({ $size }) => ($size === "small" ? "0 36px 0 36px" : "0 40px 0 40px")};
    border: 1px solid ${colors.fieldBorder};
    border-radius: ${radii.base};
    background: ${colors.surface};
    font-family: inherit;
    font-size: ${({ $size }) => ($size === "small" ? "14px" : "15px")};
    color: ${colors.textPrimary};
    outline: none;
    box-sizing: border-box;

    &:focus {
        border-color: ${colors.primary};
    }

    &::placeholder {
        color: ${colors.textSecondary};
    }
`;

export const Icon = styled.span<{ $size: SearchInputSize }>`
    position: absolute;
    left: 12px;
    display: flex;
    color: ${colors.textSecondary};
    pointer-events: none;

    svg {
        font-size: ${({ $size }) => ($size === "small" ? "16px" : "20px")};
    }
`;

export const Clear = styled.button`
    position: absolute;
    right: 6px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: ${colors.textSecondary};
    cursor: pointer;

    svg {
        font-size: 16px;
    }

    &:hover {
        background: rgba(0, 0, 0, 0.04);
    }
`;
